import React, { useEffect, useRef } from 'react';

import L from 'leaflet';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import 'leaflet.awesome-markers';

import theme from 'v3/theme';
import { Marker } from 'react-leaflet';

import ReactDOMServer from 'react-dom/server';

import { formatDateTime, formatNumber } from 'v3/utils/formatter';
import { Col, Row } from 'react-bootstrap';
import Text from '../../Text';

import MarkerContainer from './styles';

function MarkerTemperature({ paramsTemperature, background = theme.colors.primary, position, onClose }) {
  const markerRef = useRef(null);

  useEffect(() => {
    const element = markerRef.current?.getElement?.();
    const closeButton = element?.querySelector?.('.marker-temperature-close');

    if (!closeButton) return undefined;

    const handleCloseClick = (event) => {
      L.DomEvent.stopPropagation(event);
      L.DomEvent.preventDefault(event);
      onClose?.();
    };

    closeButton.addEventListener('click', handleCloseClick);

    return () => {
      closeButton.removeEventListener('click', handleCloseClick);
    };
  }, [onClose]);

  const customIcon = L.divIcon({
    className: '',
    iconAnchor: [-10, 24],
    html: ReactDOMServer.renderToString(
      <MarkerContainer background={background}>
        {onClose && (
          <button
            type="button"
            className="marker-temperature-close"
            aria-label="Fechar marcador"
          >
            ×
          </button>
        )}
        <Row>
          <Col lg={12} md={12} xs={12} style={{ marginBottom: '5px', marginTop: '5px' }}>
            {paramsTemperature?.Temperatura1 && (
              <Text color="#fff" type="label">
                Temperatura 1: {formatNumber(paramsTemperature?.Temperatura1) || 0} °C{' '}
                {formatDateTime(paramsTemperature?.datetimeTemperature1)}
              </Text>
            )}
          </Col>
          <Col lg={12} md={12} xs={12} style={{ marginBottom: '5px' }}>
            {paramsTemperature?.Temperatura2 && (
              <Text color="#fff" type="label">
                Temperatura 2: {formatNumber(paramsTemperature?.Temperatura2) || 0} °C{' '}
                {formatDateTime(paramsTemperature?.datetimeTemperature2)}
              </Text>
            )}
          </Col>
          <Col lg={12} md={12} xs={12} style={{ marginBottom: '5px' }}>
            {paramsTemperature?.Temperatura3 && (
              <Text color="#fff" type="label">
                Temperatura 3: {formatNumber(paramsTemperature?.Temperatura3) || 0} °C{' '}
                {formatDateTime(paramsTemperature?.datetimeTemperature3)}
              </Text>
            )}
          </Col>
          <Col lg={12} md={12} xs={12} style={{ marginBottom: '5px' }}>
            {paramsTemperature?.Temperatura4 && (
              <Text color="#fff" type="label">
                Temperatura 4: {formatNumber(paramsTemperature?.Temperatura4) || 0} °C{' '}
                {formatDateTime(paramsTemperature?.datetimeTemperature4)}
              </Text>
            )}
          </Col>
        </Row>
      </MarkerContainer>,
    ),
  });

  return <Marker ref={markerRef} position={position} icon={customIcon} />;
}

export default MarkerTemperature;
